import { useTypeAndDescription } from '../typeAndDescriptionContext'

import { Container } from './style'

export function CouponDescription () {
    const { couponDescription, setCouponDescription } = useTypeAndDescription()
    
    return(
        <Container>
            <label>Descrição do Cupom</label>
            <input 
                type="text" 
                placeholder="Ex: LOJA10" 
                maxLength={15} 
                value={couponDescription.toUpperCase()}
                onChange={event => setCouponDescription(event.target.value)}
            />
        </Container>
    )
}